window.addEventListener('DOMContentLoaded', (event) => {
  if (document.getElementById('jsCustomQuantitySelector') !== null) {
    var customQuantitySelector = document.getElementById('jsCustomQuantitySelector');
    var quantityMinus = customQuantitySelector.getElementsByClassName('js-quantity-minus')[0];
    var quantityPlus = customQuantitySelector.getElementsByClassName('js-quantity-plus')[0];
    var realQuantity = customQuantitySelector.getElementsByClassName('js-quantity-input-real')[0];
    var fakeQuantity = customQuantitySelector.getElementsByClassName('js-quantity-input-faux')[0];
    var quantityUnit = 1;
    
    if (customQuantitySelector.hasAttribute('data-unit')) {
      quantityUnit = parseFloat(customQuantitySelector.getAttribute('data-unit'));
    }
    
    if (customQuantitySelector.hasAttribute('data-unit-type')) {
      var quantityType = customQuantitySelector.getAttribute('data-unit-type');
      var totalQuantity = customQuantitySelector.getElementsByClassName('js-quantity-total')[0];
      var quantityPriceTotal = customQuantitySelector.getAttribute('data-unit-price');
      var quantityPriceTotalText = document.getElementById('quantity-price-total');
    }
    
    quantityMinus.addEventListener('click', function (event) {
      event.preventDefault();
      
      var fakeQuantityValue = parseFloat(fakeQuantity.value);
      
      if (fakeQuantityValue < quantityUnit) {
        fakeQuantity.value = 0;
      } else {
        fakeQuantity.value = fakeQuantityValue - quantityUnit;
      }
      
      updateQuantity(parseFloat(fakeQuantity.value));

	}, false);
    
    quantityPlus.addEventListener('click', function (event) {
      event.preventDefault();
      
      var fakeQuantityValue = parseFloat(fakeQuantity.value);
      
      fakeQuantity.value = fakeQuantityValue + quantityUnit;
      
      updateQuantity(parseFloat(fakeQuantity.value));

	}, false);
    
    fakeQuantity.addEventListener('input', function(event) {
      var inputValue = parseFloat(this.value);
      
      inputValue = (Math.round((this.value * (1 / quantityUnit)) / (1 / quantityUnit))).toFixed(2);
      
      updateQuantity(parseFloat(inputValue));
    });
    
    function updateQuantity(qty) {
      if (qty) {
        var qtyNum = parseFloat(qty);
        qtyNum = qtyNum.toFixed(2);
        
      	realQuantity.value = qtyNum * (1 / quantityUnit);
        
        if (quantityType) {
          totalQuantity.innerHTML = qtyNum + ' ' + quantityType + 's';
          quantityPriceTotalText.innerHTML = '$' + (quantityPriceTotal * realQuantity.value).toFixed(2);
        }
      }
    }
    /*Update Quantity on load*/
    
    updateQuantity(1);
  }
});